import http from '@/core/http';

const merchant = {
  actions: {
    // 添加商户
    AddGateway (ctx, payload) {
      return http.req_post('/admin/device/addmac', { ...payload });
    },
    // 获取网关列表
    GetGatewayList (ctx, payload) {
      return http.req_get('/admin/device/maclist', { ...payload });
    },
    // 获取网关详情
    GetGatewayDetail (ctx, payload) {
      return http.req_post('/admin/device/macinfo', { ...payload });
    },
    // 获取网关设备列表
    GetGatewayDeviceList (ctx, payload) {
      return http.req_post('/admin/device/macdevlist', { ...payload });
    },
    // 网关操作
    GatewayAction (ctx, payload) {
      return http.req_post('/admin/device/dodev', { ...payload }, { timeout: 1000 * 300 });
    },
    // 添加虚拟设备
    AddVirtualDevice (ctx, payload) {
      return http.req_post('/admin/device/adddev', { ...payload });
    },
    // 设备详情
    GetDeviceInfo (ctx, payload) {
      return http.req_get('/admin/device/devdetail', { ...payload });
    },
    // 设备配置属性列表
    GetDeviceAttrOptions (ctx, payload) {
      return http.req_get('/admin/device/getdevattroption', { ...payload });
    },
    // 修改设备信息
    SetDeviceInfo (ctx, payload) {
      return http.req_post('/admin/device/savedev', { ...payload });
    },
    // 批量修改设备信息
    SetDeviceInfoBatch (ctx, payload) {
      return http.req_post('/admin/device/savemultidev', { ...payload });
    },
    // 批量修改设备属性
    SetDeviceAttrBatch (ctx, payload) {
      return http.req_post('/admin/device/savemultidevattr', { ...payload });
    },
    // 修改设备场景
    SetDeviceScene (ctx, payload) {
      return http.req_post('/admin/device/savedevscene', { ...payload });
    },
    // 设备关联信息
    GetDeviceRelation (ctx, payload) {
      return http.req_post('/admin/device/getdevtotargetdata', { ...payload });
    },
    // 修改设备关联
    SetDeviceRelation (ctx, payload) {
      return http.req_post('/admin/device/savedevtotarget', { ...payload });
    },
    // 门店设备列表
    GetDevicesByStore (ctx, payload) {
      return http.req_post('/admin/action/getdevbysid', { ...payload });
    },
    // 位置已关联设备
    GetDevicesByRelated (ctx, payload) {
      return http.req_post('/admin/action/devbytarget', { ...payload });
    },
    // 修改位置已关联设备
    SetDevicesByRelated (ctx, payload) {
      return http.req_post('/admin/device/savetargettodev', { ...payload });
    },
    // 获取指令下发记录
    GetCommandRecord (ctx, payload) {
      return http.req_post('/admin/action/getdevcommandlist', { ...payload });
    },
    // 获取设备上报记录
    GetDeviceReportRecord (ctx, payload) {
      return http.req_get('/admin/device/devcommandrecord', { ...payload });
    },
    // 通通锁账号列表
    GetTTLockAccount (ctx, payload) {
      return http.req_get('/admin/device/tlockuserlist', { ...payload });
    },
    // 通通锁账号详情
    GetTTLockAccountInfo (ctx, payload) {
      return http.req_post('/admin/device/tlockuserinfo', { ...payload });
    },
    // 添加通通锁账号
    AddTTLockAccount (ctx, payload) {
      return http.req_post('/admin/device/savetlockuser', { ...payload });
    },
    // 删除通通锁账号
    DeleteTTLockAccount (ctx, payload) {
      return http.req_post('/admin/device/deltlockuser', { ...payload });
    },
    // 获取通通锁账号下的锁列表
    GetTTLockByAccount (ctx, payload) {
      return http.req_post('/admin/device/gettlockdevlistbyid', { ...payload });
    },
    // 添加通通锁到网关
    AddTTLockToGateway (ctx, payload) {
      return http.req_post('/admin/device/addtlockdev', { ...payload });
    },
    // 获取通通锁账号绑定关系
    GetTTLockAccountBindRelation (ctx, payload) {
      return http.req_post('/admin/device/tlockusertomac', { ...payload });
    },
    // 解除通通锁账号绑定关系
    UnbindTTLockAccountBindRelation (ctx, payload) {
      return http.req_post('/admin/device/unbindtlocktomac', { ...payload });
    },
    // 获取通通锁账号网关列表
    GetTTLockAccountGateways (ctx, payload) {
      return http.req_get('/admin/device/gettlockgateway', { ...payload });
    },
    // 获取通通锁账号网关下锁列表
    GetTTLocksByGateway (ctx, payload) {
      return http.req_get('/admin/device/gettlockbygateway', { ...payload });
    },
    // 获取通通锁连接的网关列表
    GetTTLockGatewayByLock (ctx, payload) {
      return http.req_get('/admin/device/gettlockgatewaybylock', { ...payload });
    },
    // 获取通通锁开门记录
    GetTTLockLog (ctx, payload) {
      return http.req_get('/admin/device/gettlockrecord', { ...payload });
    },
    // 添加开放接口门店
    AddInterfaceStore (ctx, payload) {
      return http.req_post('/admin/action/addopenapistore', { ...payload });
    },
    // 获取开放接口门店列表
    GetInterfaceStoreList (ctx, payload) {
      return http.req_get('/admin/action/openapistorelist', { ...payload });
    },
    // 设置开放接口门店状态
    SetInterfaceStatus (ctx, payload) {
      return http.req_post('/admin/action/saveopenapistorestatus', { ...payload });
    },
    // 删除开放接口门店
    DeleteInterfaceStore (ctx, payload) {
      return http.req_post('/admin/action/delopenapistore', { ...payload });
    },
    // 添加开放接口门店指令集
    AddInterfaceStoreCommand (ctx, payload) {
      return http.req_post('/admin/action/saveopenapirecord', { ...payload });
    },
    // 开放接口门店指令集列表
    GetInterfaceStoreCommands (ctx, payload) {
      return http.req_get('/admin/action/openapirecordlist', { ...payload });
    },
    // 开放接口门店指令集详情
    GetInterfaceStoreCommandInfo (ctx, payload) {
      return http.req_get('/admin/action/openapirecordinfo', { ...payload });
    },
    // 设置开放接口门店指令集状态
    SetInterfaceStoreCommandStatus (ctx, payload) {
      return http.req_get('/admin/action/saveopenapirecordstatus', { ...payload });
    },
    // 删除开放接口门店指令集
    DeleteInterfaceStoreCommand (ctx, payload) {
      return http.req_get('/admin/action/delopenapirecord', { ...payload });
    },
    // 获取开放接口门店指令集链接
    GetInterfaceStoreCommandLink (ctx, payload) {
      return http.req_get('/admin/action/getopenapirecordurl', { ...payload });
    },
    // 导出开放接口门店指令集链接
    ExportInterfaceStoreCommandLinks (ctx, payload) {
      return http.req_get('/admin/action/getopenapiurllist', { ...payload });
    },
    // 更新设备断电时间
    UpdateEndTime (ctx, payload) {
      return http.req_post('/admin/device/didendtime', { ...payload });
    },
  },
};

export default merchant;